import { createSlice } from "@reduxjs/toolkit"
import {
  searchRejected,
  searchFulfilled,
  searchPending,
} from "./search-actions"

type ResultsState = {
  hits: any[]
  status: {
    loading: boolean
    wasSearched: boolean
  }
}
export const resultsSlice = createSlice({
  name: "results",
  initialState: {
    hits: [],
    status: { loading: false, wasSearched: false },
  } as ResultsState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(searchFulfilled, (state, action) => {
      const { hits } = action.payload
      state.hits = hits
      state.status.wasSearched = true
      state.status.loading = false
    })
    builder.addCase(searchPending, (state) => {
      state.status.loading = true
    })
    builder.addCase(searchRejected, (state) => {
      state.status.loading = false
    })
  },

  selectors: {
    selectHits: (state) => state.hits,
    selectStatus: (state) => state.status,
  },
})

const { selectHits, selectStatus } = resultsSlice.selectors
export const resultsSelectors = { selectHits, selectStatus }
